import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';
import { WebhookTopics } from 'src/features/webhook-endpoints/utils/types';

const RESOURCE = '/webhooks/webhook-topics/';

type QueryFnType = typeof queryFn;

const queryFn = (): Promise<WebhookTopics> => {
    return axios.get(formatResourcePath(RESOURCE));
};

interface UseQueryHookOptions {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE],
        queryFn: async () => await queryFn(),
        ...config,
    });

export { useQueryHook as useGetWebhookTopics };
